import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteModifier } from 'api/Admin/Modifiers';

import useModal from 'lib/hooks/useModal';

import { showAlert } from 'components/shared/Alert/Alert';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';

import ModifierModal from './ModifierModal';

export const Actions = ({ data }) => {
  const { isOpen, openModal, closeModal } = useModal();
  const [deletionModal, setDeletionModal] = useState(false);
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const deleteModifierInstances = useMutation({
    mutationFn: (data) => {
      return deleteModifier(navigate, { data: [data.code] });
    },
    onSuccess: async (data) => {
      if (data.code === 0) {
        await queryClient.invalidateQueries(['modifiers']);
        showAlert({ title: 'Modifier deleted successfully', color: 'success' });
        setDeletionModal(false);
      } else {
        showAlert({
          title: data?.error ?? 'Something went wrong deleting modifier',
          color: 'danger'
        });
      }
    }
  });

  const actionOptions = [
    {
      label: 'Edit',
      icon: 'edit-2-filled',
      onClick: () => openModal()
    },
    {
      label: 'Delete',
      icon: 'trash-mono',
      onClick: () => setDeletionModal(true)
    }
  ];

  return (
    <>
      <Popover
        isFixed
        position="left"
        isBorder={false}
        options={actionOptions}
        className="flex h-full items-center"
      />
      <Confirm
        isOpen={deletionModal}
        title="Delete Modifier"
        message="Are you sure you want to delete this modifier?"
        variant="danger"
        icon="trash-mono"
        loading={deleteModifierInstances.isLoading}
        disabled={deleteModifierInstances.isLoading}
        handleClose={() => setDeletionModal(false)}
        handleContinue={() => {
          deleteModifierInstances.mutate(data);
        }}
      />
      <ModifierModal
        modifierData={data}
        isOpen={isOpen}
        modalType="edit"
        handleClose={closeModal}
      />
    </>
  );
};

export default Actions;
